import { CreateSearchConfig, SearchResults } from "../../types/coveo-types";
import { createSearch } from "../../data/coveo/search-api";

export const doLocationSearchQuery = async (
  val: string,
): Promise<SearchResults | CreateSearchConfig> => {
  const locQuery = `@state=="${val}" OR @greystar_market_area=="${val}" OR @greystar_neighborhood=="${val}" OR @state_name=="${val}"`;
  return await doSearchQuery(locQuery);
};

export const doMasterIdSearchQuery = async (
  ids: string[],
): Promise<SearchResults | CreateSearchConfig> => {
  const masterIdsQuery = ids
    .map((id) => `@master_id=="${id ?? ""}"`)
    .join(" OR ");
  return await doSearchQuery(masterIdsQuery);
};

export const doSearchQuery = async (
  query: string,
): Promise<SearchResults | CreateSearchConfig> => {
  const searchConfig = buildSearchConfig(query);
  return await createSearch(searchConfig);
};

const buildSearchConfig = (query: string): CreateSearchConfig => {
  return {
    clientId: process.env.NEXT_PUBLIC_CoveoOrganizationId as string,
    context: {
      view: {
        url: process.env.NEXT_PUBLIC_CoveoSearchHost as string,
      },
    },
    country: "US",
    currency: "USD",
    language: "en",
    query: query,
    trackingId: process.env.NEXT_PUBLIC_CoveoTrackingId as string,
  };
};
